import React from 'react';

import Searcher from 'components/DesignSystem/Searcher';
import Snackbar from 'components/DesignSystem/Snackbar';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import searchPattern from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/searchPattern';
import {
  NamedItem, SearchState, SectionState,
} from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function MultiGroupSection({
  groupedLocations, search, onSearchChange, open, onToggle,
}: SectionState & SearchState & {
  groupedLocations: {
    groups: NamedItem[];
    selectedMultiGroups: NamedItem[];
    isGroupSelected: (id: number) => boolean;
    toggleMultiGroup: (id: number) => unknown;
  };
}) {
  const pattern = searchPattern(search);

  return (
    <Section
      label="Grupos"
      valueText={groupedLocations.selectedMultiGroups.map((g) => g.name).join(', ') || undefined}
      open={open}
      onToggle={onToggle}
    >
      <Searcher value={search} onChange={(e) => onSearchChange(e.target.value)} />
      {groupedLocations.groups
        .filter((g) => pattern.test(g.name)).length === 0 && (
        <Snackbar className="mt-2">Nenhum grupo disponível</Snackbar>
      )}
      {groupedLocations.groups.filter((g) => pattern.test(g.name)).map((g) => (
        <OptionRow
          key={g.id}
          label={g.name}
          selected={groupedLocations.isGroupSelected(g.id)}
          onSelect={() => groupedLocations.toggleMultiGroup(g.id)}
          selectionType="multiple"
        />
      ))}
    </Section>
  );
}
